export const SharePointInputTypes = {
    number: "Number",
    datetime: "datetime",
    currency: "Currency",
    note: "Note",
    text: "Text",
    Boolean: "Boolean",
    url: "URL",
    choice: "Choice",
    multiChoice: "MultiChoice",
    user: "User",
    userMulti: "UserMulti",
    taxonomyFieldType: "TaxonomyFieldType",
    taxonomyFieldTypeMulti: "TaxonomyFieldTypeMulti",
    numberPercentage: "NumberPercentage",
    lookupSingle: "Lookup",
    lookupMulti: "LookupMulti",
    thumbNail: "Thumbnail"
};

export const SharePointMetadataBooleans = {
    true: "TRUE",
    false: "FALSE"
}

export const SharePointFormatTypes = {
    dateOnly: "DateOnly",
    dateTime: "DateTime",
    image: "Image",
    hyperlink: "Hyperlink",
    dropdown: "Dropdown",
    radioButtons: "RadioButtons"
}

// SharePoint keeps the SchemaXml Type attribute as authored, so a multi-value
// person/lookup column provisioned as e.g. <Field Type="User" Mult="TRUE"> still
// reports Type="User" even though TypeAsString is "UserMulti". Routing such a field
// through the single-value code paths nests its array value (breaking the people
// picker's siteuserinfolist filter) and makes save drop all but the first entry.
// Normalize to the multi type wherever SchemaXml is parsed.
export const normalizeMultiValueFieldType = (xmlData: any): any => {
    // Case-insensitive: SP normally uppercases SchemaXml booleans, but provisioning
    // templates are human-authored and may carry Mult="true".
    if (typeof xmlData?.Mult === "string" && xmlData.Mult.toUpperCase() === SharePointMetadataBooleans.true) {
        if (xmlData.Type === SharePointInputTypes.user) {
            xmlData.Type = SharePointInputTypes.userMulti;
        }
        else if (xmlData.Type === SharePointInputTypes.lookupSingle) {
            xmlData.Type = SharePointInputTypes.lookupMulti;
        }
    }
    return xmlData;
}

